import { asyncComponent } from '../../hoc'

export const DateRangePicker = asyncComponent(() => import('./DateRangePicker'))
